import selectFavoriteCategory from '../actions/selectFavoriteCategory';
import selectFolder from '../actions/selectFolder';
import selectGroup from '../actions/selectGroup';
import selectPersona from '../actions/selectPersona';
import selectPrivateDistributionList from '../actions/selectPrivateDistributionList';
import selectPreviousNodeInternal from '../actions/selectPreviousNodeInternal';
import { FolderForestNodeType } from 'owa-favorites-types';
import { getSelectedNode } from 'owa-mail-folder-forest-store';
import { mailSearchStore } from 'owa-mail-search';
import { lazyGetMailSearchNextStore } from 'owa-mail-search-next-lazy';
import { ActionSource } from 'owa-mail-store';
import { orchestrator } from 'satcheljs';
import { isFeatureEnabled } from 'owa-feature-flags';

export default orchestrator(selectPreviousNodeInternal, async actionMessage => {
    const actionSource = actionMessage.actionSource as ActionSource;

    let searchStore;
    if (isFeatureEnabled('sea-lazy2')) {
        try {
            const getSearchStore = lazyGetMailSearchNextStore.dangerouslyImportSync();
            searchStore = getSearchStore();
        } catch (e) {
            const getSearchStore = await lazyGetMailSearchNextStore.import();
            searchStore = getSearchStore();
        }
    } else {
        searchStore = mailSearchStore;
    }

    const previousNodeFromStore = searchStore.previousNode;

    // Select previous node if it was set, or the current selected node.
    // VSO #15945 - We should try to merge SelectFolder and SelectPersona logic.
    const folderNodeToSelect = previousNodeFromStore || getSelectedNode();
    switch (folderNodeToSelect.type) {
        case FolderForestNodeType.Persona:
            selectPersona(folderNodeToSelect.id);
            break;
        case FolderForestNodeType.PrivateDistributionList:
            selectPrivateDistributionList(folderNodeToSelect.id);
            break;
        case FolderForestNodeType.Folder:
            selectFolder(folderNodeToSelect.id, folderNodeToSelect.treeType, actionSource);
            break;
        case FolderForestNodeType.Category:
            selectFavoriteCategory(folderNodeToSelect.id);
            break;
        case FolderForestNodeType.Group:
            selectGroup(folderNodeToSelect.id, folderNodeToSelect.treeType);
            break;
        default:
            throw new Error('exitSearchOrchestrator: Unknown node type');
    }
});
